import { AuthorityType } from '@/types'

export interface SearchAuthorityRequest {
  authorityType: AuthorityType
  searchKey: string
  authorityIdCode: string
  authorityId: string
}

export function SearchAuthorityRequestToJSON(
  value: SearchAuthorityRequest
): any {
  return {
    authority_type:
      value.authorityType !== '' ? value.authorityType : undefined,
    search_key: value.searchKey !== '' ? value.searchKey : undefined,
    authority_id_code:
      value.authorityIdCode !== '' ? value.authorityIdCode : undefined,
    authority_id: value.authorityId !== '' ? value.authorityId : undefined
  }
}
